import React, { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Sun, Moon, Menu, PlusCircle } from 'react-feather'
import { NavItem, NavLink, Button } from 'reactstrap'
import { useHistory } from 'react-router-dom'
import UserDropdown from './UserDropdown'
import themeConfig from "@src/configs/themeConfig"
import { _walletAxiosGetAllUserAvailableBalance } from '../../../../modules/artist/redux/actions'
import { getUserData } from '@authModule'
import { CoinIcon, getLocalStorageValue, setLocalStorageValue } from '../../../../components/CurrencyComponent'
import formatAmountComponent from '../../../../components/AmountFormatComponent'

const NavbarUser = (props) => {
  const token = useSelector((state) => state.artist.token)
  const history = useHistory()
  const loggedUser = getUserData()
  const [userBalance, setUserBalance] = useState(parseFloat(getLocalStorageValue('userBalance') ?? 0.00).toFixed(2))
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 504)
  const [smallScreen, setSmallScreen] = useState(window.innerWidth)

  const handleResize = () => {
    setIsSmallScreen(window.innerWidth < 504)
    setSmallScreen(window.innerWidth)
  }

  const refreshData = () => {
    // if (!isSmallScreen) {
      _walletAxiosGetAllUserAvailableBalance(token, '£-GBP', 0,
        (data) => {
          setLocalStorageValue('userBalance', data?.data.balance?.balance ?? '0.00')
          const storedBalance = parseFloat(getLocalStorageValue('userBalance') ?? 0.00).toFixed(2)
          setUserBalance(storedBalance)
        },
        (error) => {
          console.error('Error fetching balance:', error)
        }
      )
    // }
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)

    let interval

    // if (!isSmallScreen) {
      // eslint-disable-next-line prefer-const
      interval = setInterval(refreshData, 20000)
    // }

    return () => {
      clearInterval(interval)
      window.removeEventListener('resize', handleResize)
    }
  }, [isSmallScreen, token])

  useEffect(() => {
    refreshData()
  }, [isSmallScreen])

  const { setMenuVisibility, setMenuCollapsed, menuCollapsed, windowWidth } = props

  return (
    <Fragment>
      <ul className='navbar-nav d-flex align-items-center navbar-collapse'>
        {windowWidth < 1200 ? (
          <NavItem className='mobile-menu mr-auto'>
            <NavLink className='nav-menu-main menu-toggle hidden-xs is-active' onClick={() => setMenuVisibility(true)}>
              <Menu className='ficon' />
            </NavLink>
          </NavItem>
        ) : (
          <NavItem className='mobile-menu mr-auto'>
            <NavLink className='nav-menu-main menu-toggle hidden-xs is-active' onClick={() => setMenuCollapsed(!menuCollapsed)}>
              <Menu className='ficon' />
            </NavLink>
          </NavItem>
        )}

        <div className='d-flex align-items-center ml-auto'>
          {!isSmallScreen && (
            <NavItem>
              <NavLink>
                <h6
                  onClick={() => {
                    loggedUser.user_type_id === 1 ? history.push('/wallet/user/transaction') : history.push('/payouts/list')
                  }}
                  className='balance-display'
                  style={{ margin: '0 5px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                >
                  Balance:&nbsp;<CoinIcon width={15} />&nbsp;{formatAmountComponent(`${userBalance}`)}
                </h6>
              </NavLink>
            </NavItem>
          )}

          {loggedUser.user_type_id === 1 && (
            <Button.Ripple type='button' className='btn btn-primary btn-sm flex-grow-1' color='primary' onClick={() => history.push('/select/platform')}
              style={{ margin: '0 10px', maxWidth: 'fit-content' }}>
              <span style={{ fontSize: '11px' }}>Create Campaign <PlusCircle size={15} /></span>
            </Button.Ripple>
          )}
        </div>

        <UserDropdown />
      </ul>
    </Fragment>
  )
}

export default NavbarUser
